import React, { useEffect, useRef, useState } from "react";
import medicine from "../../assets/Icons/med1.svg";
import Home from "../../assets/Icons/Home.svg";
import Hours from "../../assets/Icons/Hours.svg";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { DatePicker, Flex, message, Modal, Select, Spin, Switch } from "antd";
import { IoMdAddCircle } from "react-icons/io";
import { FiChevronDown, FiChevronUp, FiEye, FiFilePlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  AddtoCart,
  getCartDetails,
  updateCartState,
} from "../../Redux/actions/cartActions";
import Layout from "../../Layout";
import moment from "moment";
import { Base64 } from "js-base64";
import sha256 from "crypto-js/sha256";
import { convertUTCDate } from "../../utils/convertionFunc";
import MembershipBg from "../../assets/Icons/membershipbgImagecolour.svg";
import { CheckOutlined } from "@ant-design/icons";
import { Buffer } from "buffer";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getCurrentTime } from "../../Shared/CartHelper";
import LocationService from "../../Services/LocationService";
import CartOrderService from "../../Services/CartOrderService";
import PaymentService from "../../Services/PaymentService";
import PatientService from "../../Services/PatientService";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { fetchMembershipPlans } from "../../Redux/actions/membershipActions";
import { MdFamilyRestroom } from "react-icons/md";
window.Buffer = Buffer;

const defaultAddressFields = {
  address1: "",
  city: "",
  country: "",
  mobile: "",
  pinCode: "",
  state: "",
};

function MyCart() {
  const medicinePrescriptionInputRef = useRef(null);
  const labPrescriptionInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isMedicineOpen, setIsMedicineOpen] = useState(true);
  const [isLabOpen, setIsLabOpen] = useState(true);
  const [isServicesOpen, setIsServicesOpen] = useState(true);
  const [selected, setSelected] = useState(null);
  const [isAddressesModalOpen, setIsAddressesModalOpen] = useState(false);
  const [newAddModal, setNewAddModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [makeThidAddY, setMakeThisAddY] = useState(null);
  const [formData, setFormData] = useState(defaultAddressFields);
  const [payOptionMod, setPayOptionMod] = useState(false);
  const [cartLoader, setCartLoader] = useState(false);
  const [prefferedDate, setPreferredDate] = useState("");
  const [labTestOrdType, setLabTestOrdType] = useState("");
  const [userCurrWallet, setUserCurrWallet] = useState(null);
  const [patientMembershipDet, setPatientMembershipDet] = useState([]);
  const [patMembershipDrug, setPatMembershipDrug] = useState(null);
  const [patMembershipLab, setPatMembershipLab] = useState(null);
  const [patMembershipInclinic, setPatMembershipInclinic] = useState(null);
  const [membershipAvailed, setMembershipAvalied] = useState(false);
  const [grandTotalPaidAmount, setGrandTotalPaidAmount] = useState(0);
  const [saveLoader, setSaveLoader] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [membershipLoading, setMembershipLoading] = useState(false);
  const [medicinePrescription, setMedicinePrescription] = useState("");
  const [medicinePrescriptionFileName, setMedicinePrescriptionFileName] =
    useState("");
  const [medicinePrescriptionType, setMedicinePrescriptionType] = useState("");
  const [medicinePrescriptionPreview, setMedicinePrescriptionPreview] =
    useState("");
  const [labPrescription, setLabPrescription] = useState("");
  const [labPrescriptionFileName, setLabPrescriptionFileName] = useState("");
  const [labPrescriptionType, setLabPrescriptionType] = useState("");
  const [labPrescriptionPreview, setLabPrescriptionPreview] = useState("");
  const [activePrescriptionPreview, setActivePrescriptionPreview] = useState({
    image: "",
    fileName: "",
  });
  const [isPrescriptionPreviewOpen, setIsPrescriptionPreviewOpen] =
    useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { states, countries } = useSelector((state) => state.common);
  const { cartData } = useSelector((state) => state.cart);
  const selectedPatient = useSelector((state) => state.auth.patientData);
  const { memberShipPlans, isLoading } = useSelector(
    (state) => state.memberships,
  );
  const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";
  const COUNTRYCODE = process.env.REACT_APP_COUNTRYCODE || "";

  useEffect(() => {
    const loadData = async () => {
      const payload = { patientId: selectedPatient?.patientId };

      try {
        await Promise.all([
          getPatientAddresses(),
          dispatch(getCartDetails(payload)),
          fetchFamilyMembers(),
        ]);
        setMembershipLoading(true);

        if (selectedPatient?.membershipCard) {
          await fetchMembershipDetails(selectedPatient?.membershipCard);
        } else {
          setPatientMembershipDet([]);
          dispatch(fetchMembershipPlans({ status: 1 }));
        }
      } catch (err) {
        console.error("Error loading patient data:", err);
      } finally {
        setMembershipLoading(false);
      }
    };

    loadData();
  }, [selectedPatient]);
  const [cartOrderFor, setCartOrder] = useState(selectedPatient);
  useEffect(() => {
    if (cartOrderFor && cartOrderFor?.membershipCard) {
      fetchMembershipDetails(cartOrderFor?.membershipCard);
    } else {
      setPatientMembershipDet([]);
      dispatch(fetchMembershipPlans({ status: 1 }));
    }
  }, [cartOrderFor]);

  useEffect(() => {
    if (cartData) {
      const total = cartData?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);
      setGrandTotalPaidAmount(total);
      const isMemAvailed =
        cartData?.cartOrderHdr[0]?.isMembershipDiscount === "Y";
      if (isMemAvailed === undefined || isMemAvailed === null) {
        return;
      } else if (isMemAvailed && !membershipAvailed) {
        cartRevertBack();
      }
    } else {
      setGrandTotalPaidAmount(0);
    }
  }, [cartData]);

  const fetchMembershipDetails = async (membershipCard) => {
    const payload = {
      membershipCard,
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      setPatientMembershipDet(response?.data?.data || []);

      if (!response?.data?.data) return;

      if (response?.data?.data) {
        const membershipArray = response?.data?.data;
        const drugObj = membershipArray?.find(
          (item) => item.serviceCategory === "DRUG",
        );
        const labObj = membershipArray?.find(
          (item) => item.serviceCategory === "PATHOLOGY",
        );
        const inclinicObj = membershipArray?.find(
          (item) => item.serviceCategory === "INCLINIC",
        );
        setPatMembershipDrug(drugObj);
        setPatMembershipLab(labObj);
        setPatMembershipInclinic(inclinicObj);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getPatientAddresses = async () => {
    const payload1 = {
      patientId: selectedPatient?.patientId,
      status: 1,
    };

    const payload2 = {
      patientId: selectedPatient?.patientId,
      status: 1,
      defaultAddressYN: "Y",
    };

    try {
      const [result1, result2] = await Promise.all([
        LocationService.getPatientAddress(payload1),
        LocationService.getPatientAddress(payload2),
      ]);
      if (result1.data.length > 0) {
        setAddresses(result1.data);
      } else {
        setAddresses([]); // Optional: clear if no data
      }
      if (result2.data.length > 0) {
        setAddressData(result2.data[0]);
      } else {
        setAddressData(null); // Optional: clear if no default found
      }
    } catch (error) {
      console.error("Failed to fetch patient addresses:", error);
    }
  };

  const getDiscountPercent = (cartHdr, cartItem, memBenefitsArray) => {
    if (!memBenefitsArray || !Array.isArray(memBenefitsArray)) return 0;

    const orderType = cartHdr?.orderType || cartItem?.orderType;
    if (orderType === "DRUG") {
      const drugCategory = cartItem?.drugCategory;
      const drugMembership = memBenefitsArray.find(
        (membItem) =>
          (drugCategory && membItem.serviceCategory === drugCategory) ||
          membItem.serviceCategory === "RX",
      );
      return Number(drugMembership?.discountPercentage) || 0;
    } else if (orderType === "LAB") {
      const labCategory = cartHdr?.labCategory || cartItem?.labCategory;
      if (labCategory === "Internal Lab Test") {
        const inclinicMembership = memBenefitsArray.find(
          (membItem) => membItem.serviceCategory === "INCLINIC",
        );
        return Number(inclinicMembership?.discountPercentage) || 0;
      } else {
        // External Lab Test
        const testType = cartItem?.testType;
        const labMembership = memBenefitsArray.find(
          (membItem) =>
            (testType && membItem.serviceCategory === testType) ||
            membItem.serviceCategory === "PATHOLOGY",
        );
        return Number(labMembership?.discountPercentage) || 0;
      }
    } else if (orderType === "OPSERVICE") {
      const inclinicMembership = memBenefitsArray.find(
        (membItem) => membItem.serviceCategory === "INCLINIC",
      );
      return Number(inclinicMembership?.discountPercentage) || 0;
    }

    return 0;
  };

  const calculateDiscountedPrice = (cartHdr, cartItem, memBenefitsArray) => {
    const orderType = cartHdr?.orderType || cartItem?.orderType;
    const currentPrice =
      orderType === "DRUG"
        ? Number(cartItem?.paidAmount) || 0
        : orderType === "LAB" || orderType === "OPSERVICE"
          ? Number(cartItem?.unitPrice) || 0
          : 0;

    const discountPercent = getDiscountPercent(
      cartHdr,
      cartItem,
      memBenefitsArray,
    );
    const discountAmount = Math.floor(currentPrice * (discountPercent / 100));
    return currentPrice - discountAmount;
  };

  const calculateDiscountAmount = (cartHdr, cartItem, memBenefitsArray) => {
    const orderType = cartHdr?.orderType || cartItem?.orderType;
    const currentPrice =
      orderType === "DRUG"
        ? Number(cartItem?.paidAmount) || 0
        : orderType === "LAB" || orderType === "OPSERVICE"
          ? Number(cartItem?.unitPrice) || 0
          : 0;

    const discountPercent = getDiscountPercent(
      cartHdr,
      cartItem,
      memBenefitsArray,
    );
    const discountAmount = Math.floor(currentPrice * (discountPercent / 100));
    return discountAmount;
  };

  const findCategory = (itemHdr, item) => {
    if (itemHdr?.orderType === "DRUG") {
      return item?.drugCategory;
    } else if (
      itemHdr?.orderType === "LAB" &&
      itemHdr?.labCategory === "External Lab Test"
    ) {
      return item?.testType;
    } else if (
      itemHdr?.orderType === "LAB" &&
      itemHdr?.labCategory === "Internal Lab Test"
    ) {
      return "INCLINIC";
    } else if (itemHdr?.orderType === "OPSERVICE") {
      return "INCLINIC";
    }
  };

  const calculateTotalSavedAmt = () => {
    let totalWithDiscount = 0;
    let totalWithoutDiscount = 0;
    const membershipDetList = Array.isArray(patientMembershipDet)
      ? patientMembershipDet
      : [];

    cartData?.cartOrderHdr?.forEach((item) => {
      if (item.orderType === "DRUG") {
        for (let drug of item.cartOrderDtl) {
          const price = Number(drug.paidAmount) || 0;
          totalWithoutDiscount += price;
          let drugMembership;
          for (let membItem of membershipDetList) {
            if (
              membItem.serviceCategory === drug.drugCategory ||
              membItem.serviceCategory === "RX"
            ) {
              drugMembership = membItem;
            }
          }
          const discountPercent =
            Number(drugMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalDrugPrice = price - discountAmount;
          totalWithDiscount += finalDrugPrice;
        }
      }

      if (item.orderType === "LAB") {
        for (let lab of item.cartOrderDtl) {
          const price = Number(lab.unitPrice) || 0;
          totalWithoutDiscount += price;
          let labMembership;
          if (item.labCategory === "Internal Lab Test") {
            for (let membItem of membershipDetList) {
              if (membItem.serviceCategory === "INCLINIC") {
                labMembership = membItem;
              }
            }
          } else if (item.labCategory === "External Lab Test") {
            for (let membItem of membershipDetList) {
              if (
                membItem.serviceCategory === lab.testType ||
                membItem.serviceCategory === "PATHOLOGY"
              ) {
                labMembership = membItem;
              }
            }
          }

          const discountPercent =
            Number(labMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalLabPrice = price - discountAmount;
          totalWithDiscount += finalLabPrice;
        }
      }

      if (item.orderType === "OPSERVICE") {
        for (let opservice of item.cartOrderDtl) {
          const price = Number(opservice.unitPrice) || 0;
          totalWithoutDiscount += price;
          let inclinicMembership;
          for (let membItem of membershipDetList) {
            if (membItem.serviceCategory === "INCLINIC") {
              inclinicMembership = membItem;
            }
          }
          const discountPercent =
            Number(inclinicMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalLabPrice = price - discountAmount;
          totalWithDiscount += finalLabPrice;
        }
      }
    });

    return totalWithoutDiscount - totalWithDiscount;
  };

  const calcTotSavedAmtForActivation = () => {
    let totalWithDiscount = 0;
    let totalWithoutDiscount = 0;
    const singlePlan = memberShipPlans?.find(
      (item) => item.code === "SINGLE",
    )?.membershipServiceDetailsList;

    cartData?.cartOrderHdr?.forEach((item) => {
      if (item.orderType === "DRUG") {
        for (let drug of item.cartOrderDtl) {
          const price = Number(drug.paidAmount) || 0;
          totalWithoutDiscount += price;
          const drugMembership = singlePlan?.find(
            (item) => item.serviceCategory === "RX",
          );
          const discountPercent =
            Number(drugMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalDrugPrice = price - discountAmount;
          totalWithDiscount += finalDrugPrice;
        }
      }

      if (item.orderType === "LAB") {
        let membership;
        if (item.labCategory === "Internal Lab Test") {
          membership = singlePlan?.find(
            (item) => item.serviceCategory === "INCLINIC",
          );
        } else if (item.labCategory === "External Lab Test") {
          membership = singlePlan?.find(
            (item) => item.serviceCategory === "PATHOLOGY",
          );
        }

        for (let lab of item.cartOrderDtl) {
          const price = Number(lab.unitPrice) || 0;
          totalWithoutDiscount += price;
          const labMembership = membership;
          const discountPercent =
            Number(labMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalLabPrice = price - discountAmount;
          totalWithDiscount += finalLabPrice;
        }
      }

      if (item.orderType === "OPSERVICE") {
        for (let opservice of item.cartOrderDtl) {
          const price = Number(opservice.unitPrice) || 0;
          totalWithoutDiscount += price;
          const labMembership = singlePlan?.find(
            (item) => item.serviceCategory === "INCLINIC",
          );
          const discountPercent =
            Number(labMembership?.discountPercentage) || 0;
          const discountAmount = Math.floor(price * (discountPercent / 100));
          const finalLabPrice = price - discountAmount;
          totalWithDiscount += finalLabPrice;
        }
      }
    });

    return totalWithoutDiscount - totalWithDiscount;
  };

  const calcHighDiscPercent = () => {
    if (patientMembershipDet && patientMembershipDet.length > 0) {
      let max = -1;
      for (let plan of patientMembershipDet) {
        if (plan?.serviceCategory !== "APPT") {
          max = Math.max(Number(plan?.discountPercentage) || 0, max);
        }
      }
      return max;
    } else {
      if (memberShipPlans) {
        const singlePlan = memberShipPlans?.find(
          (item) => item.code === "SINGLE",
        )?.membershipServiceDetailsList;
        let max = -1;
        if (singlePlan) {
          for (let plan of singlePlan) {
            if (plan?.serviceCategory !== "APPT") {
              max = Math.max(Number(plan?.discountPercentage) || 0, max);
            }
          }
        }
        return max;
      }
    }
    return 0;
  };

  const membershipType = () => {
    if (!patientMembershipDet || patientMembershipDet.length === 0) return "";
    return patientMembershipDet[0]?.membershipCode === "SINGLE"
      ? "Single member"
      : patientMembershipDet[0]?.membershipCode === "TWIN"
        ? "Twin members"
        : patientMembershipDet[0]?.membershipCode === "FAMILY"
          ? "Family"
          : "";
  };

  const totalQuantity = cartData?.cartOrderHdr?.reduce((qtySum, order) => {
    const itemQty = order?.cartOrderDtl?.reduce(
      (sum, item) => sum + (item?.quantity || 0),
      0,
    );
    return qtySum + itemQty;
  }, 0);

  const hasMedicineInCart = cartData?.cartOrderHdr?.some(
    (order) =>
      order.orderType === "DRUG" &&
      Array.isArray(order.cartOrderDtl) &&
      order.cartOrderDtl.length > 0,
  );
  const hasLabInCart = cartData?.cartOrderHdr?.some(
    (order) =>
      order.orderType === "LAB" &&
      Array.isArray(order.cartOrderDtl) &&
      order.cartOrderDtl.length > 0,
  );

  const handlePrescriptionChange = (event, orderType) => {
    const file = event.target.files?.[0];
    event.target.value = "";

    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase() || "";
    if (!["jpg", "jpeg", "png"].includes(fileExtension)) {
      message.error("Please upload a JPG, JPEG, or PNG image.");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      message.error("Prescription image must be smaller than 10 MB.");
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => {
      message.error("Unable to read the prescription image. Please try again.");
    };
    reader.onload = () => {
      const dataUrl = reader.result;
      const imageData = typeof dataUrl === "string" ? dataUrl : "";
      if (orderType === "DRUG") {
        setMedicinePrescription(imageData.split(",")[1] || "");
        setMedicinePrescriptionFileName(file.name);
        setMedicinePrescriptionType(fileExtension);
        setMedicinePrescriptionPreview(imageData);
      } else {
        setLabPrescription(imageData.split(",")[1] || "");
        setLabPrescriptionFileName(file.name);
        setLabPrescriptionType(fileExtension);
        setLabPrescriptionPreview(imageData);
      }
    };
    reader.readAsDataURL(file);
  };

  const removePrescription = (orderType) => {
    if (orderType === "DRUG") {
      setMedicinePrescription("");
      setMedicinePrescriptionFileName("");
      setMedicinePrescriptionType("");
      setMedicinePrescriptionPreview("");
    } else {
      setLabPrescription("");
      setLabPrescriptionFileName("");
      setLabPrescriptionType("");
      setLabPrescriptionPreview("");
    }
    setIsPrescriptionPreviewOpen(false);
  };

  const viewPrescription = (image, fileName) => {
    setActivePrescriptionPreview({ image, fileName });
    setIsPrescriptionPreviewOpen(true);
  };

  const updateQuantity = async (orderIndex, itemIndex, action) => {
    const updatedCart = { ...cartData };
    const drugOrders = updatedCart.cartOrderHdr.filter(
      (order) => order.orderType === "DRUG",
    );
    const selectedOrder = drugOrders[orderIndex];
    const selectedItem = selectedOrder.cartOrderDtl[itemIndex];

    if (!selectedItem) return;
    setLoader(true);
    if (action === "increase") {
      selectedItem.quantity += 1;
      selectedItem.paidAmount = selectedItem.quantity * selectedItem.unitPrice;
      selectedItem.orderState = "U";
    } else if (action === "decrease") {
      if (selectedItem.quantity <= 1) {
        // Treat this as a remove action
        selectedItem.status = 0;
        selectedItem.orderState = "U";
      } else {
        selectedItem.quantity -= 1;
        selectedItem.paidAmount =
          selectedItem.quantity * selectedItem.unitPrice;
        selectedItem.orderState = "U";
      }
    } else if (action === "remove") {
      selectedItem.status = 0;
      selectedItem.orderState = "U";
    }

    const activeItems = selectedOrder.cartOrderDtl.filter(
      (item) => item.status !== 0,
    );
    const totalPaid = activeItems.reduce(
      (sum, item) => sum + (item.paidAmount || 0),
      0,
    );

    selectedOrder.amount = totalPaid;
    selectedOrder.paidAmount = totalPaid;
    try {
      const updateCartData = await dispatch(AddtoCart(updatedCart));
      // dispatch(updateCartState(updateCartData.data));
      const cartPayload = { patientId: selectedPatient?.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleLabItemRemove = async (category, orderIndex, itemIndex) => {
    const updatedCart = { ...cartData };
    const labOrders = updatedCart.cartOrderHdr.filter(
      (order) => order.orderType === "LAB",
    );
    const selectedOrder = labOrders[orderIndex];
    const selectedItem = selectedOrder.cartOrderDtl[itemIndex];

    if (!selectedItem) return;
    setLoader(true);
    selectedItem.status = 0;
    selectedItem.orderState = "U";

    const activeItems = selectedOrder.cartOrderDtl.filter(
      (item) => item.status !== 0,
    );
    const totalPaid = activeItems.reduce(
      (sum, item) => sum + (item.paidAmount || 0),
      0,
    );

    selectedOrder.amount = totalPaid;
    selectedOrder.paidAmount = totalPaid;

    try {
      const updateCartData = await dispatch(AddtoCart(updatedCart));
      // dispatch(updateCartState(updateCartData.data));
      const cartPayload = { patientId: selectedPatient?.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleOPItemRemove = async (orderIndex, itemIndex) => {
    const updatedCart = { ...cartData };
    const labOrders = updatedCart.cartOrderHdr.filter(
      (order) =>
        order.orderType === "OPSERVICE" ||
        order.orderType === "INCLINICSERVICE",
    );
    const selectedOrder = labOrders[orderIndex];
    const selectedItem = selectedOrder.cartOrderDtl[itemIndex];

    if (!selectedItem) return;
    setLoader(true);
    selectedItem.status = 0;
    selectedItem.orderState = "U";

    const activeItems = selectedOrder.cartOrderDtl.filter(
      (item) => item.status !== 0,
    );
    const totalPaid = activeItems.reduce(
      (sum, item) => sum + (item.paidAmount || 0),
      0,
    );

    selectedOrder.amount = totalPaid;
    selectedOrder.paidAmount = totalPaid;

    try {
      const updateCartData = await dispatch(AddtoCart(updatedCart));
      // dispatch(updateCartState(updateCartData.data));
      const cartPayload = { patientId: selectedPatient?.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.error(e);
    }
  };

  const handleMembershipRemove = async (orderIndex) => {
    if (!cartData?.cartOrderHdr) return;

    const updatedCart = { ...cartData };
    const memberships = updatedCart.cartOrderHdr.filter(
      (order) => order.orderType === "MEMBERSHIP",
    );
    const selectedOrder = memberships[orderIndex];
    if (!selectedOrder) return;

    setLoader(true);

    // Soft-delete items
    const updatedDtl =
      selectedOrder?.cartOrderDtl?.map((item) => ({
        ...item,
        orderState: "U",
        status: 0,
      })) || [];

    const updatedOrder = {
      ...selectedOrder,
      cartOrderDtl: updatedDtl,
    };

    updatedCart.cartOrderHdr = updatedCart.cartOrderHdr.map((order) =>
      order.id === selectedOrder.id ? updatedOrder : order,
    );

    try {
      await dispatch(AddtoCart(updatedCart));
      dispatch(getCartDetails({ patientId: selectedPatient?.patientId }));
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  const handleProceedPayment = async (paymentOption = "Digital") => {
    if (!cartData || cartData.cartOrderHdr.length === 0) return;

    const hasDeliveryItems = cartData?.cartOrderHdr?.some(
      (order) => order.orderType === "DRUG" || order.orderType === "LAB",
    );

    if (hasDeliveryItems) {
      if (!addressData || !addressData.pinCode) {
        message.error("Please select a delivery address.");
        return;
      }
      if (COUNTRYCODE == "IN") {
        try {
          let payload = {
            pincode: addressData.pinCode,
            status: 1,
          };
          setCartLoader(true);
          let result = await LocationService.checkAvailability(payload);
          if (result.data.length === 0) {
            setCartLoader(false);
            message.error(
              "Service is not available for the selected delivery address. Please choose a different address.",
            );
            return;
          }
          setCartLoader(false);
        } catch (error) {
          console.error(error);
          setCartLoader(false);
          message.error("Failed to check service availability.");
          return;
        }
      }
    }

    const isTestThere =
      cartData?.cartOrderHdr?.filter((order) => order.orderType === "LAB")
        .length > 0;
    if (isTestThere) {
      if (!prefferedDate || !labTestOrdType) {
        message.error("Please select test date and collection type.");
        return;
      }
    }

    const updatedHdr = cartData.cartOrderHdr.map((order) => {
      if (order.orderType === "DRUG") {
        return {
          ...order,
          prescription: medicinePrescription,
          // prescriptionFileName: medicinePrescriptionFileName,
          prescriptionType: medicinePrescriptionType,
        };
      }

      if (order.orderType === "LAB") {
        return {
          ...order,
          prescription: labPrescription,
          // prescriptionFileName: labPrescriptionFileName,
          prescriptionType: labPrescriptionType,
          labTestType: labTestOrdType,
          preferredDateAndTime: convertUTCDate(
            prefferedDate,
            "YYYY-MM-DD HH:mm:ss",
          ),
        };
      }

      return order;
    });

    const updatedCartData = { ...cartData, cartOrderHdr: updatedHdr };
    let cartPayload;
    let currGrandTotal;

    setCartLoader(true);
    const UpdateAddress = updatedCartData.cartOrderHdr.map((item) => ({
      cartId: item.cartId,
      deliveryAddress1: addressData?.address1,
      deliveryCity: addressData?.city,
      deliveryCountry: addressData?.country,
      deliveryState: addressData?.state,
      deliveryZipCode: addressData?.pinCode,
      modifiedBy: selectedPatient?.patientId,
      orderId: item.orderId,
    }));

    try {
      await CartOrderService.UpdateCartAddress(UpdateAddress);

      // Updating payment type in cartdetails.
      cartPayload = { ...updatedCartData };
      if (patientMembershipDet?.length !== 0 && membershipAvailed) {
        const updatedHdrWithMembership = updatedCartData.cartOrderHdr.map(
          (hdr) => {
            const updatedDtl = hdr.cartOrderDtl.map((dtl) => {
              const gross = dtl.unitPrice * dtl.quantity;
              const membershipDis = calculateDiscountAmount(
                hdr,
                dtl,
                patientMembershipDet,
              );
              const amountAfterDis =
                dtl.unitPrice * dtl.quantity - membershipDis;

              return {
                ...dtl,
                amount: gross,
                membershipDiscount: membershipDis,
                paidAmount: Number(parseFloat(amountAfterDis).toFixed(2)),
              };
            });

            const totalAmount = updatedDtl.reduce(
              (sum, i) => sum + i.amount,
              0,
            );
            const totalPaidAmount = updatedDtl.reduce(
              (sum, i) => sum + i.paidAmount,
              0,
            );
            const totalDiscount = totalAmount - totalPaidAmount;
            const discountCategory = findCategory(hdr, updatedDtl) || "";
            const discountPercent =
              patientMembershipDet?.find(
                (item) => item.serviceCategory === discountCategory,
              )?.discountPercentage || 0;

            return {
              ...hdr,
              cartOrderDtl: updatedDtl,
              membershipCard: patientMembershipDet[0].membershipCard,
              membershipCode: patientMembershipDet[0].membershipCode,
              membershipName: patientMembershipDet[0].membershipCode,
              isMembershipDiscount: "Y",
              membershipDiscount: totalDiscount,
              amount: totalAmount,
              paidAmount: totalPaidAmount,
              discountAmount: totalDiscount?.toFixed(2),
              discountPercentage: discountPercent,
            };
          },
        );

        cartPayload = {
          ...cartPayload,
          cartOrderHdr: updatedHdrWithMembership,
        };
      }

      if (paymentOption === "Digital") {
        currGrandTotal = grandTotalPaidAmount;
        if (membershipAvailed) {
          currGrandTotal = grandTotalPaidAmount - calculateTotalSavedAmt();
        }
        if (CURRENCYCODE !== "INR") {
          cartPayload = {
            ...cartPayload,
            paymentType: "VirtualCash",
            txnType: "DEBIT",
            walletId: "",
            userId: "",
            totalAmount: currGrandTotal,
          };
        } else {
          cartPayload = {
            ...cartPayload,
            paymentType: paymentOption,
            totalAmount: currGrandTotal,
          };
        }
      }

      //  setCartLoader(false);
      // return;

      if (CURRENCYCODE !== "INR") {
        await CartOrderService.AddToCartWithoutDP(cartPayload);
        dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
        message.success("Payment successfull");
        navigate(APP_ROUTES.HOME);
        return;
      }
      await CartOrderService.AddToCart(cartPayload);
      // dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
    } catch (error) {
      console.error(error);
      message.error("Something went wrong. Please try after sometime!!");
      setCartLoader(false);
      return;
    }

    if (paymentOption === "Digital") {
      let grandTotalAmount = cartData?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.amount || 0);
      }, 0);

      let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
      let transactionId = "MT" + date;
      let cartPaymentDetails =
        transactionId +
        "|" +
        selectedPatient.patientId +
        "|" +
        updatedCartData.cartId;
      let base64string = Base64.encode(cartPaymentDetails);

      // let paymentPayload = {
      //     merchantTransactionId: transactionId,
      //     amount: parseFloat(cartPayload?.totalAmount) * 100,
      //     redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}/phonepepayment/${base64string}`,
      //     redirectMode: "POST",
      //     callbackUrl: `${process.env.REACT_APP_BASE_URL}/phonePeResponse1/paymentCallBackDetails`,
      //     mobileNumber: "",
      //     paymentInstrument: {
      //         type: "PAY_PAGE",
      //     },
      // };

      let paymentPayload = {
        merchantOrderId: transactionId,
        amount: parseFloat(cartPayload?.totalAmount) * 100,
        expireAfter: 1200,
        metaInfo: {
          udf1: "Cart Orders",
        },
        redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
      };

      const SALT_KEY = process.env.REACT_APP_PHONEPE_SALT_KEY;
      const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
      let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
      let base64EncodedPayload = bufferObj.toString("base64");
      let string = base64EncodedPayload + "/pg/v1/pay" + SALT_KEY;
      let sha256_val = sha256(string);
      let xVerifyChecksum = sha256_val + "###" + 1;
      let phonepeTransaction = {
        checksum: xVerifyChecksum,
        createdBy: selectedPatient?.patientId,
        createdDate: getCurrentTime(),
        modifiedDate: getCurrentTime(),
        paidDate: getCurrentTime(),
        modifiedBy: selectedPatient?.patientId,
        patientId: selectedPatient?.patientId,
        enoCodePayload: base64EncodedPayload,
        providerreferenceId: "",
        serviceCode: "CART",
        serviceName: "Cart Order",
        status: 1,
        serviceTransId: updatedCartData.cartId,
        transactionId: transactionId,
        cartId: updatedCartData.cartId,
        userId: selectedPatient.createdBy,
        amount: parseFloat(cartPayload?.totalAmount).toFixed(2),
      };
      try {
        const result =
          await PaymentService.PhonepeTransaction(phonepeTransaction);

        if (result.data === 1) {
          let billingTransaction = {
            // account_Id: selectedPatient?.account_Id,
            account_Id: selectedPatient?.account_Id,
            amount: parseFloat(grandTotalAmount).toFixed(2),
            // clinic_id: selectedPatient?.clinic_Id,
            clinic_id: selectedPatient?.clinic_Id,
            createdBy: selectedPatient?.patientId,
            createdDate: getCurrentTime(),
            discountAmount: 0,
            discountPercentage: 0,
            gst: 0,
            modifiedBy: selectedPatient?.patientId,
            modifiedDate: getCurrentTime(),
            paidAmount: parseFloat(cartPayload?.totalAmount).toFixed(2),
            patientId: selectedPatient.patientId,
            paymentDate: getCurrentTime(),
            paymode: "PhonePe",
            serviceCode: "CART",
            serviceCost: parseFloat(grandTotalAmount).toFixed(2),
            serviceName: "CART ORDER",
            serviceTransId: updatedCartData.cartId,
            status: 0,
            cartId: updatedCartData.cartId,
            transactionId: transactionId,
            userId: selectedPatient.createdBy,
            billingTransactionServices: cartPayload.cartOrderHdr.map(
              (item) => ({
                // account_Id: selectedPatient?.account_Id,
                account_Id: selectedPatient?.account_Id,
                // amount: parseFloat(totalPaidAmount).toFixed(2),
                amount: item.amount,
                // clinic_id: selectedPatient?.clinic_Id,
                clinic_id: selectedPatient?.clinic_Id,
                createdBy: selectedPatient?.patientId,
                createdDate: getCurrentTime(),
                fromDate: getCurrentTime(),
                modifiedBy: selectedPatient?.patientId,
                modifiedDate: getCurrentTime(),
                // paidAmount: parseFloat(totalPaidAmount).toFixed(2),
                paidAmount: item.paidAmount,
                patientId: selectedPatient.patientId,
                paymentDate: getCurrentTime(),
                paymode: "PhonePe",
                serviceCode:
                  item.orderType === "DRUG"
                    ? "DRUG-ORDERS"
                    : item.orderType === "LAB"
                      ? "LAB-ORDERS"
                      : item.orderType === "OPSERVICE"
                        ? "OPSERVICE-ORDERS"
                        : "",
                // serviceCost: parseFloat(totalPaidAmount).toFixed(2),
                serviceCost: item.amount,
                serviceName:
                  item.orderType === "DRUG"
                    ? "Drug Orders"
                    : item.orderType === "LAB"
                      ? "Lab Orders"
                      : item.orderType === "OPSERVICE"
                        ? "Opservice Orders"
                        : "",
                serviceTransId: cartData.cartId,
                status: 0,
                toDate: getCurrentTime(),
                transactionId: transactionId,
                cartId: item.cartId,
                orderId: item?.orderId,
                userId: selectedPatient.createdBy,
                discountAmount: item.discountAmount,
                discountPercentage: item.discountPercentage,
                gst: 0,
              }),
            ),
          };

          const billingResult =
            await PaymentService.BillingTransaction(billingTransaction);
          if (billingResult.data === 1) {
            // const configurationObject = {
            //     method: "POST",
            //     url: PHONE_PE_HOST_URL,
            //     data: { request: base64EncodedPayload },
            //     headers: {
            //         Accept: "application/json",
            //         "Content-Type": "application/json",
            //         "X-VERIFY": xVerifyChecksum,
            //     },
            // };
            const response =
              await PaymentService.initiatePayment(paymentPayload);
            dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
            window.location.replace(response.data.redirectUrl);
          }
        }
        setCartLoader(false);
      } catch (error) {
        console.error("Warning", error);
        setCartLoader(false);
        message.error("Something went wrong. Please try after sometime.");
        await cartRevertBack();
        return error.response;
      }
    }
  };

  const handleSelectedAddress = (addressObj, idx) => {
    setMakeThisAddY(addressObj);
    setSelected(idx);
  };

  const handleDefAddChangeMod = () => {
    setIsAddressesModalOpen(true);
  };

  const handleCloseDefAddChangeMod = () => {
    setIsAddressesModalOpen(false);
  };

  const handleUpdateDefaultAddress = async () => {
    if (!makeThidAddY) {
      message.error("Something went wrong. Please try after sometime!!");
      return;
    }
    let payload = {
      defaultAddressYN: "Y",
      id: makeThidAddY?.id,
      patientId: makeThidAddY?.patientId,
      status: 1,
    };
    setSaveLoader(true);
    try {
      await LocationService.setDefaultAddress(payload);
    } catch (e) {
      console.error(e);
      setSaveLoader(false);
    } finally {
      getPatientAddresses();
      setIsAddressesModalOpen(false);
      setSaveLoader(false);
    }
  };

  const handleNewAddressMod = () => {
    setNewAddModal(true);
  };

  const handleCloseNewAddressMod = () => {
    setNewAddModal(false);
    setFormData(defaultAddressFields);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddressSave = async (e) => {
    e.preventDefault();
    const isFormEmpty = Object.values(formData).some(
      (value) => value.trim() === "",
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: selectedPatient.account_Id,
      clinic_Id: selectedPatient.clinic_Id,
      createdBy: selectedPatient?.patientId,
      modifiedBy: selectedPatient?.patientId,
      patientId: selectedPatient.patientId,
      defaultAddressYN: "N",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    setSaveLoader(true);
    try {
      await LocationService.savePatientAddress(payload);
    } catch (error) {
      console.error(error);
      setSaveLoader(false);
    } finally {
      setNewAddModal(false);
      setSaveLoader(false);
      getPatientAddresses();
    }
  };

  const handlePayOptionMod = () => {
    const isTestThere =
      cartData?.cartOrderHdr?.filter((order) => order.orderType === "LAB")
        .length > 0;
    if (isTestThere) {
      if (!prefferedDate || !labTestOrdType) {
        message.error("Please select test date and collection type.");
        return;
      }
    }
    setPayOptionMod(true);
  };

  const handlePayModCancel = () => {
    setPayOptionMod(false);
  };

  const handlePrefferedDate = (dateObj) => {
    // const selectedDay = dayjs(dateObj).format('MM/DD/YYYY').toString()
    setPreferredDate(dateObj);
  };

  const handleLabTestType = (value) => {
    setLabTestOrdType(value);
  };

  const handleMembershipSelection = (value) => {
    setMembershipAvalied(value);
  };

  const handleNavigateToMemberhsip = () => {
    navigate(APP_ROUTES.JOINMEMBERSHIP);
  };

  const cartRevertBack = async () => {
    if (!cartData?.cartOrderHdr?.length) return;

    // Check if revert is really needed
    const hasMembershipAvailed = cartData.cartOrderHdr.some(
      (hdr) => hdr.isMembershipDiscount === "Y",
    );
    if (!hasMembershipAvailed) return;

    const revertedHdr = cartData.cartOrderHdr.map((hdr) => {
      const updatedDtl = hdr.cartOrderDtl.map((dtl) => ({
        ...dtl,
        membershipDiscount: 0,
        paidAmount: Number(dtl.unitPrice * dtl.quantity).toFixed(2),
      }));

      const totalAmount = updatedDtl.reduce(
        (sum, i) => sum + i.unitPrice * i.quantity,
        0,
      );
      const totalPaidAmount = updatedDtl.reduce(
        (sum, i) => sum + Number(i.paidAmount),
        0,
      );

      return {
        ...hdr,
        cartOrderDtl: updatedDtl,
        membershipCard: "",
        membershipCode: "",
        membershipName: "",
        isMembershipDiscount: "N",
        membershipDiscount: 0,
        amount: totalAmount,
        paidAmount: totalPaidAmount,
      };
    });

    const revertPayload = { ...cartData, cartOrderHdr: revertedHdr };

    try {
      await CartOrderService.AddToCart(revertPayload);
      dispatch(getCartDetails({ patientId: selectedPatient.patientId }));
    } catch (err) {
      console.error("Cart revert failed:", err);
      message.error("Unable to revert cart. Please refresh and try again.");
    }
  };

  const fetchFamilyMembers = async () => {
    const payload = {
      currentPatient: selectedPatient?.patientId,
      parentPatientId: selectedPatient?.parentPatientId
        ? selectedPatient?.parentPatientId
        : selectedPatient?.patientId,
      includeParentPatientYN: "Y",
    };

    try {
      const res = await PatientService.PatientList(payload);
      setFamilyMembers(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectFamilyMember = async (patId) => {
    if (!patId) {
      message.error("No patient found!!");
      return;
    }
    const selectedPat = familyMembers.find((fam) => fam.patientId === patId);
    if (!selectedPat) return;

    if (!cartData) return;
    const payload = {
      cartId: cartData.cartId,
      patientId: patId,
      orderingPatientId: selectedPatient?.patientId,
    };
    try {
      await CartOrderService.transferCartItems(payload);
      setCartOrder(selectedPat);
      message.success("Cart items moved to selected patient's cart");
      return;
    } catch (e) {
      console.error(e);
    }
  };

  // const handleSelectedPatient = async (currSelPat) => {
  //   if (!currSelPat) {
  //     message.error("Please select a patient");
  //     return;
  //   }
  //   if (currSelPat) {
  //     localStorage.removeItem("membership");
  //     dispatch(setSelectedPatient(currSelPat));
  //     localStorage.setItem("selectedPatient", JSON.stringify(currSelPat));
  //     if (currSelPat?.membershipCard) {
  //       const payload = {
  //         membershipCard: currSelPat?.membershipCard,
  //       };
  //       const response = await PatientService.patientMembershipDet(payload);
  //       if (response?.data?.data?.[0]) {
  //         localStorage.setItem(
  //           "membership",
  //           response?.data?.data?.[0].membershipCode,
  //         );
  //       }
  //     }
  //   }
  // };

  return (
    <Layout>
      <div className="p-5 w-[90%] m-auto">
        <div className="flex sm:flex-col items-center gap-5 justify-between">
          <h3 className="w-[60%]text-[#189FAA] font-sans font-semibold text-lg">
            My Cart
          </h3>
          <div className="w-[40%] sm:w-full px-5">
            {!selectedPatient?.parentPatientId && (
              <div className="flex items-center gap-2">
                <MdFamilyRestroom className="sm:hidden block text-brand-primaryColor" />{" "}
                <Select
                  className="w-[45%] sm:w-full h-9"
                  placeholder="Select family member"
                  onChange={handleSelectFamilyMember}
                  options={familyMembers?.map((familyMem) => {
                    return {
                      label: `${familyMem.firstName} ${familyMem?.lastName}`,
                      value: familyMem.patientId,
                    };
                  })}
                />
              </div>
            )}
          </div>
        </div>

        <div className=" flex sm:flex-col gap-5 mt-5">
          <div className="w-[60%] sm:w-full">
            <div className="border rounded-md">
              <div className="flex justify-between p-3">
                <p className="text-[#333333] font-sans font-semibold text-sm">
                  Delivery Address
                </p>
                <p
                  className="text-[#189FAA] font-sans cursor-pointer font-semibold text-sm"
                  onClick={handleDefAddChangeMod}
                >
                  Change
                </p>
              </div>
              <hr className="" />
              {addressData?.address1 && (
                <p className="text-[#333333] font-sans font-medium text-sm p-2 w-80 sm:w-full mx-2">
                  {addressData?.address1},
                  {addressData?.address2 ? `${addressData?.address2},` : ""}{" "}
                  {addressData.city} – {addressData.pinCode}.
                </p>
              )}
            </div>
            <div>
              {loader ? (
                <div className="flex items-center justify-center mt-[10%]">
                  <Flex align="center" gap="middle">
                    <Spin size="large" tip="Loading" />
                  </Flex>
                </div>
              ) : (
                <div className="border rounded-md mt-4 p-3">
                  <div className="h-[500px] overflow-y-scroll scrollWidth space-y-4">
                    <div className="border rounded-md shadow">
                      <div className="w-full bg-cyan-100 px-4 py-2 rounded-t-md flex items-center justify-between">
                        <button
                          type="button"
                          onClick={() => setIsMedicineOpen(!isMedicineOpen)}
                          className="flex flex-1 items-center justify-between pr-3 text-left text-sm font-bold text-cyan-700"
                        >
                          Medicines
                          {isMedicineOpen ? <FiChevronUp /> : <FiChevronDown />}
                        </button>

                        {hasMedicineInCart && (
                          <div className="flex items-center gap-2">
                            <input
                              ref={medicinePrescriptionInputRef}
                              type="file"
                              accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                              className="hidden"
                              onChange={(event) =>
                                handlePrescriptionChange(event, "DRUG")
                              }
                            />
                            <button
                              type="button"
                              onClick={() =>
                                medicinePrescriptionInputRef.current?.click()
                              }
                              className="inline-flex items-center gap-1.5 rounded-md bg-cyan-700 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-cyan-800 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
                            >
                              <FiFilePlus
                                className="text-sm"
                                aria-hidden="true"
                              />
                              {medicinePrescriptionFileName
                                ? "Change Prescription"
                                : "Upload Prescription"}
                            </button>
                          </div>
                        )}
                      </div>
                      {medicinePrescriptionFileName && (
                        <div className="flex items-center justify-between gap-2 border-b border-cyan-100 bg-cyan-50 px-4 py-2 text-xs">
                          <span className="truncate text-cyan-800">
                            {/* Prescription: {medicinePrescriptionFileName} */}
                          </span>
                          <div className="flex shrink-0 gap-2">
                            <button
                              type="button"
                              aria-label="View medicine prescription"
                              title="View prescription"
                              onClick={() =>
                                viewPrescription(
                                  medicinePrescriptionPreview,
                                  medicinePrescriptionFileName,
                                )
                              }
                              className="text-cyan-700 hover:text-cyan-800"
                            >
                              <FiEye className="text-base" />
                            </button>
                            <button
                              type="button"
                              aria-label="Remove medicine prescription"
                              title="Remove prescription"
                              onClick={() => removePrescription("DRUG")}
                              className="text-red-600 hover:text-red-700"
                            >
                              <RiDeleteBin6Line className="text-base" />
                            </button>
                          </div>
                        </div>
                      )}
                      {isMedicineOpen && (
                        <div className="flex flex-col gap-3 p-4">
                          {cartData?.cartOrderHdr &&
                            cartData.cartOrderHdr.filter(
                              (order) => order.orderType === "DRUG",
                            ).length > 0 &&
                            cartData.cartOrderHdr
                              .filter((order) => order.orderType === "DRUG")
                              .map((order, orderIndex) =>
                                order?.cartOrderDtl?.map((item, itemIndex) => (
                                  <article
                                    key={item.id}
                                    className="relative flex flex-col w-full bg-white rounded-md border shadow-2xl border-slate-200 h-[220px]  overflow-y-auto"
                                  >
                                    <header className="flex justify-between items-center mx-3">
                                      <h2 className="py-5 text-xs font-semibold text-cyan-600">
                                        Medicine
                                      </h2>
                                      <div
                                        className="w-7 h-7 border rounded-full flex justify-center items-center cursor-pointer"
                                        onClick={() =>
                                          updateQuantity(
                                            orderIndex,
                                            itemIndex,
                                            "remove",
                                          )
                                        }
                                      >
                                        <RiDeleteBin6Line className="text-red-500" />
                                      </div>
                                    </header>

                                    <div className="flex sm:flex-col gap-3.5 items-start px-4">
                                      <figure className="flex justify-center items-center p-2 rounded shadow-2xl border border-slate-400 h-[54px]">
                                        <img
                                          src={medicine}
                                          alt={item?.orderName}
                                          className="w-[50px] h-[39px] object-contain"
                                        />
                                      </figure>
                                      <div className="flex flex-col gap-1.5">
                                        <h3 className="text-sm font-semibold text-black">
                                          {item?.orderName}
                                        </h3>
                                        <p className="text-xs text-gray-500">
                                          {item?.quantity ? item?.quantity : 0}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="absolute right-4 top-[71px] flex flex-col items-end gap-0.5">
                                      <div className="flex gap-3 items-center">
                                        <span className="text-lg sm:text-sm font-bold text-zinc-800">
                                          <span className="text-sm font-normal text-gray-400 mr-0.5">
                                            {`${CURRENCYCODE} `}
                                          </span>
                                          {item?.paidAmount
                                            ? item.paidAmount.toFixed(2)
                                            : "0.00"}
                                        </span>
                                      </div>
                                      {patientMembershipDet?.length !== 0 && (
                                        <div className="flex items-center gap-2 my-2">
                                          {/* <div
                                                                                                className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${patMembershipDrug?.membershipCode === "SINGLE"
                                                                                                    ? "from-[#81CAF4] to-[#58B4E9]"
                                                                                                    : patMembershipDrug?.membershipCode === "TWIN"
                                                                                                        ? "from-[#5DEB6D] to-[#34CF47]"
                                                                                                        : patMembershipDrug?.membershipCode === "FAMILY" ? "from-[#35D9D4] to-[#1DBBB6]" : ''
                                                                                                    }`}
                                                                                            >
                                                                                                <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                                                                                    <span className="font-medium text-sm">
                                                                                                        {patMembershipDrug?.membershipCode === "SINGLE"
                                                                                                            ? "Single member"
                                                                                                            : patMembershipDrug?.membershipCode === "TWIN"
                                                                                                                ? "Twin members"
                                                                                                                : patMembershipDrug?.membershipCode === "FAMILY" ? "Family" : ''}
                                                                                                    </span>
                                                                                                    <span className="text-xs font-normal text-gray-500">Membership</span>
                                                                                                </p>
                                                                                            </div> */}

                                          <div className="flex items-center gap-1">
                                            <span className="text-lg font-sans font-semibold text-[#333333]">
                                              <span className="text-sm font-normal text-gray-400 mr-0.5">
                                                {`${CURRENCYCODE} `}
                                              </span>
                                              {calculateDiscountedPrice(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              )?.toFixed(2)}
                                            </span>
                                            <span className="line-through text-[#738483] font-opensans text-base">
                                              {item?.paidAmount}
                                            </span>
                                            <span className="text-[#117F0D]">
                                              (Save{" "}
                                              {calculateDiscountAmount(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              ) || "-"}
                                              )
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <footer className="absolute inset-x-0 bottom-0 flex justify-between items-center px-4 py-2 bg-slate-50 border-t border-slate-300">
                                      <div className="flex gap-3 items-center">
                                        {/* <p className="text-xs text-zinc-800">
                                                                            {item.deliveryText}
                                                                        </p> */}
                                        <div className="w-px bg-slate-400 h-[22px]" />
                                        <div className="flex gap-1.5 items-center">
                                          {item.deliveryCharge > 0 ? (
                                            <>
                                              <span className="text-sm text-gray-500 line-through">
                                                <span className="text-sm font-normal text-gray-400 mr-0.5">
                                                  {`${CURRENCYCODE} `}
                                                </span>
                                                {item.deliveryCharge}
                                              </span>
                                              <span className="text-xs text-lime-600">
                                                Free
                                              </span>
                                            </>
                                          ) : (
                                            <span className="text-xs text-lime-600">
                                              Free
                                            </span>
                                          )}
                                        </div>
                                      </div>

                                      <div className="flex gap-2 items-center px-3 py-1.5 border border-slate-300 rounded-full">
                                        <button
                                          disabled={item?.quantity === 1}
                                          className="p-px bg-slate-200 h-[18px] w-[18px] rounded-full flex justify-center items-center disabled:cursor-not-allowed disabled:opacity-50"
                                          onClick={() =>
                                            updateQuantity(
                                              orderIndex,
                                              itemIndex,
                                              "decrease",
                                            )
                                          }
                                        >
                                          <AiOutlineMinus className="text-teal-600 text-sm" />
                                        </button>
                                        <span className="text-base font-semibold text-zinc-800">
                                          {item?.quantity || 0}
                                        </span>
                                        <button
                                          className="p-px bg-cyan-600 h-[18px] w-[18px] rounded-full flex justify-center items-center"
                                          onClick={() =>
                                            updateQuantity(
                                              orderIndex,
                                              itemIndex,
                                              "increase",
                                            )
                                          }
                                        >
                                          <AiOutlinePlus className="text-white text-sm" />
                                        </button>
                                      </div>
                                    </footer>
                                  </article>
                                )),
                              )}
                        </div>
                      )}
                    </div>
                    <div className="border rounded-md shadow">
                      <div className="w-full bg-[#EFFEFF] px-4 py-2 rounded-t-md flex items-center justify-between">
                        <button
                          type="button"
                          onClick={() => setIsLabOpen(!isLabOpen)}
                          className="flex flex-1 items-center justify-between pr-3 text-left text-sm font-bold text-[#189FAA]"
                        >
                          Lab Tests
                          {isLabOpen ? <FiChevronUp /> : <FiChevronDown />}
                        </button>

                        {hasLabInCart && (
                          <div>
                            <input
                              ref={labPrescriptionInputRef}
                              type="file"
                              accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                              className="hidden"
                              onChange={(event) =>
                                handlePrescriptionChange(event, "LAB")
                              }
                            />
                            <button
                              type="button"
                              onClick={() =>
                                labPrescriptionInputRef.current?.click()
                              }
                              className="inline-flex items-center gap-1.5 rounded-md bg-cyan-700 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-cyan-800 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-1"
                            >
                              <FiFilePlus
                                className="text-sm"
                                aria-hidden="true"
                              />
                              {labPrescriptionFileName
                                ? "Change Prescription"
                                : "Upload Prescription"}
                            </button>
                          </div>
                        )}
                      </div>
                      {labPrescriptionFileName && (
                        <div className="flex items-center justify-between gap-2 border-b border-cyan-100 bg-cyan-50 px-4 py-2 text-xs">
                          <span className="truncate text-cyan-800">
                            {/* Prescription: {labPrescriptionFileName} */}
                          </span>
                          <div className="flex shrink-0 gap-2">
                            <button
                              type="button"
                              aria-label="View lab prescription"
                              title="View prescription"
                              onClick={() =>
                                viewPrescription(
                                  labPrescriptionPreview,
                                  labPrescriptionFileName,
                                )
                              }
                              className="text-cyan-700 hover:text-cyan-800"
                            >
                              <FiEye className="text-base" />
                            </button>
                            <button
                              type="button"
                              aria-label="Remove lab prescription"
                              title="Remove prescription"
                              onClick={() => removePrescription("LAB")}
                              className="text-red-600 hover:text-red-700"
                            >
                              <RiDeleteBin6Line className="text-base" />
                            </button>
                          </div>
                        </div>
                      )}
                      {isLabOpen && (
                        <div className="flex flex-col gap-3 p-4">
                          <div>
                            {cartData?.cartOrderHdr &&
                              cartData.cartOrderHdr.filter(
                                (order) => order.orderType === "LAB",
                              ).length > 0 && (
                                <div className="flex flex-col items-end w-full">
                                  <div className="flex items-center gap-2 space-x-2 mt-3">
                                    <p className="font-light text-sm">
                                      Preferred Date :
                                    </p>
                                    <DatePicker
                                      disabledDate={(current) =>
                                        current.isBefore(dayjs(), "day")
                                      }
                                      className=""
                                      onChange={handlePrefferedDate}
                                      showTime={{ format: "hh:mm A" }}
                                      format="DD/MM/YYYY hh:mm A"
                                      needConfirm={false}
                                    />
                                  </div>
                                  <div className="flex items-center space-x-2 mt-3">
                                    <label
                                      htmlFor="sample-collection-method"
                                      className="text-sm font-medium"
                                    >
                                      Collection Type :
                                    </label>
                                    <Select
                                      className="w-36"
                                      id="sample-collection-method"
                                      onChange={handleLabTestType}
                                      dropdownStyle={{ width: "12rem" }}
                                      options={[
                                        {
                                          label: "Home Sample Collection",
                                          value: "home",
                                        },
                                        {
                                          label: "Lab Centre Visit",
                                          value: "labcentre",
                                        },
                                      ].map((item, idx) => {
                                        return {
                                          label: item.label,
                                          value: item.value,
                                          key: idx,
                                        };
                                      })}
                                    />
                                    {/* <button className="text-xs flex gap-2 items-center font-sans font-medium bg-[#EFFBFF] border-[#B9EFFF] border text-[#333333] px-2 py-1 rounded">
                                                                                <img src={Home} alt="" /> Home Sample Collection
                                                                            </button>
                                                                            <button className="text-xs flex gap-2 items-center bg-purple-100 text-[#333333] font-sans font-medium px-2 py-1 rounded">
                                                                                <img src={Lab} alt="" /> Lab Centre Visit
                                                                            </button> */}
                                  </div>
                                </div>
                              )}
                          </div>
                          {cartData?.cartOrderHdr &&
                            cartData.cartOrderHdr.filter(
                              (order) => order.orderType === "LAB",
                            ).length > 0 &&
                            cartData.cartOrderHdr
                              .filter((order) => order.orderType === "LAB")
                              .map((order, orderIndex) =>
                                order?.cartOrderDtl?.map((item, itemIndex) => (
                                  <article
                                    key={item.id}
                                    className="relative flex flex-col w-full bg-white rounded-md border shadow-2xl border-slate-200 relative flex flex-col w-full bg-white rounded-md border shadow-2xl border-slate-200 min-h-[320px] sm:min-h-[400px] md:min-h-[500px] h-auto overflow-y-autmin-h-[200px] h-max overflow-y-auto"
                                  >
                                    <header className="flex justify-between items-center px-4">
                                      <h2 className="py-4 text-xs font-semibold text-[#189FAA]">
                                        Lab Test
                                      </h2>
                                      <div
                                        className="w-7 h-7 border rounded-full flex justify-center items-center"
                                        onClick={() =>
                                          handleLabItemRemove(
                                            order.labCategory,
                                            orderIndex,
                                            itemIndex,
                                          )
                                        }
                                      >
                                        <RiDeleteBin6Line className="text-red-500 cursor-pointer" />
                                      </div>
                                    </header>

                                    <div className="flex sm:flex-col justify-between items-start px-4">
                                      <div className="flex flex-col gap-1.5">
                                        <h3 className="text-sm font-semibold text-black">
                                          {item?.orderName}
                                        </h3>
                                        <p className="text-xs text-[#189FAA] font-medium">
                                          {item.quantity}
                                        </p>
                                      </div>
                                      <div className="flex flex-col gap-0.5 items-end">
                                        <div className="flex gap-3 items-center">
                                          <span className="text-lg font-bold text-zinc-800">
                                            <span className="text-sm font-normal text-gray-400 mr-0.5">
                                              {`${CURRENCYCODE} `}
                                            </span>
                                            {item?.unitPrice
                                              ? item.unitPrice.toFixed(2)
                                              : "0.00"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-end mr-4">
                                      {patientMembershipDet?.length !== 0 && (
                                        <div className="flex items-center gap-2 my-2">
                                          {/* <div
                                                                                            className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${patMembershipLab?.membershipCode === "SINGLE"
                                                                                                ? "from-[#81CAF4] to-[#58B4E9]"
                                                                                                : patMembershipLab?.membershipCode === "TWIN"
                                                                                                    ? "from-[#5DEB6D] to-[#34CF47]"
                                                                                                    : patMembershipLab?.membershipCode === "FAMILY" ? "from-[#35D9D4] to-[#1DBBB6]" : ''
                                                                                                }`}
                                                                                        >
                                                                                            <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                                                                                <span className="font-medium text-sm">
                                                                                                    {patMembershipLab?.membershipCode === "SINGLE"
                                                                                                        ? "Single member"
                                                                                                        : patMembershipLab?.membershipCode === "TWIN"
                                                                                                            ? "Twin members"
                                                                                                            : patMembershipLab?.membershipCode === "FAMILY" ? "Family" : ''}
                                                                                                </span>
                                                                                                <span className="text-xs font-normal text-gray-500">Membership</span>
                                                                                            </p>
                                                                                        </div> */}

                                          <div className="flex items-center gap-1">
                                            <span className="text-lg font-sans font-semibold text-[#333333]">
                                              <span className="text-sm font-normal text-gray-400 mr-0.5">
                                                {`${CURRENCYCODE} `}
                                              </span>
                                              {calculateDiscountedPrice(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              )?.toFixed(2)}
                                            </span>
                                            <span className="line-through text-[#738483] font-opensans text-base">
                                              {item.unitPrice}
                                            </span>
                                            <span className="text-[#117F0D]">
                                              (Save{" "}
                                              {calculateDiscountAmount(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              ) || "-"}
                                              )
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <footer className="w-[inherit] mt-5 absolute bottom-0 flex justify-between items-center px-4 py-2 bg-[#EFFEFF] border-t border-[#CFE6E7] rounded-b-md">
                                      <div className="flex gap-3 items-center">
                                        <p className="text-xs text-zinc-800 flex gap-2 items-center">
                                          <img
                                            src={Home}
                                            alt=""
                                            className="w-4 h-4"
                                          />
                                          {item.deliveryText}
                                        </p>
                                        <div className="w-px bg-slate-400 h-[22px]" />
                                        <p className="text-xs text-zinc-800 flex gap-2 items-center">
                                          <img
                                            src={Hours}
                                            alt=""
                                            className="w-4 h-4"
                                          />
                                          24–48 hours
                                        </p>
                                      </div>
                                    </footer>
                                  </article>
                                )),
                              )}
                        </div>
                      )}
                    </div>
                    <div className="border rounded-md shadow">
                      <button
                        onClick={() => setIsServicesOpen(!isServicesOpen)}
                        className="w-full bg-green-100 px-4 py-2 text-left text-sm font-bold text-green-700 rounded-t-md flex justify-between items-center"
                      >
                        <span>Services</span>
                        {isServicesOpen ? <FiChevronUp /> : <FiChevronDown />}
                      </button>

                      {isServicesOpen && (
                        <div className="flex flex-col gap-3 p-4 bg-white border rounded-b-md shadow-md">
                          {cartData?.cartOrderHdr &&
                            cartData.cartOrderHdr.filter((order) =>
                              ["OPSERVICE"].some((type) =>
                                order.orderType.includes(type),
                              ),
                            ).length > 0 &&
                            cartData.cartOrderHdr
                              .filter((order) =>
                                ["OPSERVICE"].some((type) =>
                                  order.orderType.includes(type),
                                ),
                              )
                              .map((order, orderIndex) =>
                                order?.cartOrderDtl?.map((item, itemIndex) => (
                                  <article
                                    key={item.id}
                                    className="relative flex flex-col w-full bg-white rounded-md border shadow-2xl border-slate-200"
                                  >
                                    <header className="flex justify-between items-center px-4">
                                      <div className="flex gap-2 items-center">
                                        <p className="text-xs font-sans font-semibold text-[#868585]">
                                          Category:
                                        </p>
                                        <h2 className="py-4 text-sm text-black font-semibold font-sans">
                                          {item.orderType === "OPSERVICE"
                                            ? "OP Service"
                                            : "Internal Test"}
                                        </h2>
                                      </div>

                                      <div
                                        className="w-7 h-7 border rounded-full flex justify-center items-center"
                                        onClick={() =>
                                          handleOPItemRemove(
                                            orderIndex,
                                            itemIndex,
                                          )
                                        }
                                      >
                                        <RiDeleteBin6Line className="text-red-500 cursor-pointer" />
                                      </div>
                                    </header>

                                    <div className="flex justify-between items-start px-4">
                                      <div className="flex gap-2 items-center">
                                        <p className="text-xs font-sans font-semibold text-[#868585]">
                                          Service:
                                        </p>
                                        <h3 className="text-sm font-semibold text-[#189FAA] font-sans">
                                          {item?.orderName}
                                        </h3>
                                      </div>
                                      <div className="flex flex-col gap-0.5 items-end">
                                        <div className="flex gap-3 items-center">
                                          <span className="text-lg font-bold text-zinc-800 font-sans">
                                            <span className="text-sm font-normal text-gray-400 mr-0.5">
                                              {`${CURRENCYCODE} `}
                                            </span>
                                            {item?.unitPrice
                                              ? item.unitPrice.toFixed(2)
                                              : "0.00"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-end mr-4">
                                      {patientMembershipDet?.length !== 0 && (
                                        <div className="flex items-center gap-2 my-2">
                                          {/* <div
                                                                                        className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${patMembershipInclinic?.membershipCode === "SINGLE"
                                                                                            ? "from-[#81CAF4] to-[#58B4E9]"
                                                                                            : patMembershipInclinic?.membershipCode === "TWIN"
                                                                                                ? "from-[#5DEB6D] to-[#34CF47]"
                                                                                                : patMembershipInclinic?.membershipCode === "FAMILY" ? "from-[#35D9D4] to-[#1DBBB6]" : ''
                                                                                            }`}
                                                                                    >
                                                                                        <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                                                                            <span className="font-medium text-sm">
                                                                                                {patMembershipInclinic?.membershipCode === "SINGLE"
                                                                                                    ? "Single member"
                                                                                                    : patMembershipInclinic?.membershipCode === "TWIN"
                                                                                                        ? "Twin members"
                                                                                                        : patMembershipInclinic?.membershipCode === "FAMILY" ? "Family" : ''}
                                                                                            </span>
                                                                                            <span className="text-xs font-normal text-gray-500">Membership</span>
                                                                                        </p>
                                                                                    </div> */}

                                          <div className="flex items-center gap-1">
                                            <span className="text-lg font-sans font-semibold text-[#333333]">
                                              <span className="text-sm font-normal text-gray-400 mr-0.5">
                                                {`${CURRENCYCODE} `}
                                              </span>
                                              {calculateDiscountedPrice(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              )?.toFixed(2)}
                                            </span>
                                            <span className="line-through text-[#738483] font-opensans text-base">
                                              {item.unitPrice}
                                            </span>
                                            <span className="text-[#117F0D]">
                                              (Save{" "}
                                              {calculateDiscountAmount(
                                                order,
                                                item,
                                                patientMembershipDet,
                                              ) || "-"}
                                              )
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </article>
                                )),
                              )}

                          <>
                            {cartData?.cartOrderHdr &&
                              cartData.cartOrderHdr.filter((order) =>
                                ["MEMBERSHIP"].some((type) =>
                                  order.orderType.includes(type),
                                ),
                              ).length > 0 &&
                              cartData.cartOrderHdr
                                .filter((order) =>
                                  ["MEMBERSHIP"].some((type) =>
                                    order.orderType.includes(type),
                                  ),
                                )
                                .map((order, orderIndex) => (
                                  <article
                                    key={order.id}
                                    className="relative flex flex-col w-full bg-white rounded-md border shadow-2xl border-slate-200"
                                  >
                                    <header className="flex justify-between items-center px-4">
                                      <div className="flex gap-2 items-center">
                                        <p className="text-xs font-sans font-semibold text-[#868585]">
                                          Category:
                                        </p>
                                        <h2 className="py-4 text-sm text-black font-semibold font-sans">
                                          Membership
                                        </h2>
                                      </div>

                                      <div
                                        onClick={() =>
                                          handleMembershipRemove(orderIndex)
                                        }
                                        className="w-7 h-7 border rounded-full flex justify-center items-center"
                                      >
                                        <RiDeleteBin6Line className="text-red-500 cursor-pointer" />
                                      </div>
                                    </header>

                                    <div className="flex justify-between items-start px-4">
                                      <div className="flex gap-2 items-center">
                                        <p className="text-xs font-sans font-semibold text-[#868585]">
                                          Service:
                                        </p>
                                        <h3 className="text-sm font-semibold text-[#189FAA] font-sans">
                                          {order?.membershipName}
                                        </h3>
                                      </div>
                                      <div className="flex flex-col gap-0.5 items-end">
                                        <div className="flex gap-3 items-center">
                                          <span className="text-lg font-bold text-zinc-800 font-sans">
                                            <span className="text-sm font-normal text-gray-400 mr-0.5">
                                              {`${CURRENCYCODE} `}
                                            </span>
                                            {order?.paidAmount
                                              ? order.paidAmount.toFixed(2)
                                              : "0.00"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </article>
                                ))}
                          </>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="w-[40%] sm:w-full">
            <div className="p-4 bg-white rounded-md border shadow-2xl border-neutral-200 h-[380px] w-[356px] sm:w-full">
              <div className="flex justify-between items-center mb-5">
                <div className="text-sm font-semibold tracking-normal font-sans">
                  Apply Coupon
                </div>
                <div className="text-xs text-cyan-600 underline font-sans font-medium cursor-pointer">
                  My Coupons
                </div>
              </div>
              <div className="flex gap-3 mb-5">
                <div className="flex w-full">
                  <input
                    type="text"
                    placeholder="Enter coupon code"
                    className="px-4 w-full h-8 text-xs placeholder:text-xs rounded border border-zinc-400 text-neutral-400 outline-none"
                  />
                </div>
                <button className="px-3.5 py-2 text-xs font-semibold text-white bg-cyan-600 rounded">
                  Apply
                </button>
              </div>

              {/* Membership details */}
              {membershipLoading ? (
                <div className="h-[230px] flex items-center justify-center">
                  <Flex align="center" gap="middle">
                    <Spin size="large" tip="Loading" />
                  </Flex>
                </div>
              ) : patientMembershipDet?.length !== 0 ? (
                <div
                  style={{
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}
                  className="w-full font-inter overflow-hidden bg-brand-White rounded-2xl"
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: "linear-gradient(to right, #e3f0f9, #d6e6ef)",
                      padding: "12px 16px",
                      borderBottom: "1px solid #e5e7eb",
                      backgroundImage: `url(${MembershipBg})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <div>
                        {/* <CheckOutlined style={{ color: "#1976d2" }} /> */}
                        <div
                          className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${
                            patientMembershipDet[0]?.membershipCode === "SINGLE"
                              ? "from-[#81CAF4] to-[#58B4E9]"
                              : patientMembershipDet[0]?.membershipCode ===
                                  "TWIN"
                                ? "from-[#5DEB6D] to-[#34CF47]"
                                : patientMembershipDet[0]?.membershipCode ===
                                    "FAMILY"
                                  ? "from-[#35D9D4] to-[#1DBBB6]"
                                  : ""
                          }`}
                        >
                          <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                            <span className="font-medium text-sm">
                              {membershipType()}
                            </span>
                            <span className="text-xs font-normal text-gray-500">
                              Membership
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div className="text-lg font-semibold text-brand-White">
                        DOXZON
                      </div>
                      <div className="text-[8px] font-semibold text-brand-White">
                        Technology for Health
                      </div>
                    </div>
                  </div>

                  {/* Body */}
                  <div style={{ padding: "16px" }}>
                    <div
                      style={{
                        color: "#16a34a",
                        fontWeight: 600,
                        fontSize: 18,
                        marginBottom: 6,
                      }}
                      className={`${calculateTotalSavedAmt() <= 0 ? "hidden" : ""}`}
                    >
                      Save{" "}
                      <span className="text-sm font-normal text-gray-400 mr-0.5">
                        {`${CURRENCYCODE} `}
                      </span>{" "}
                      {calculateTotalSavedAmt()?.toFixed(2)}
                    </div>

                    <div
                      style={{
                        color: "#374151",
                        lineHeight: 1.4,
                        fontSize: 14,
                        marginBottom: 16,
                      }}
                    >
                      Get {calcHighDiscPercent()}% off on each product item you
                      buy with your {membershipType()?.split(" ")[0]}{" "}
                      Membership.
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontWeight: 500, color: "#374151" }}>
                        Use membership to get discount
                      </span>
                      <Switch
                        value={membershipAvailed}
                        onChange={handleMembershipSelection}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                memberShipPlans &&
                memberShipPlans
                  ?.filter((item) => item.code === "SINGLE")
                  ?.map((item) => (
                    <div
                      style={{
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      }}
                      className="w-full font-inter overflow-hidden bg-brand-White rounded-2xl"
                    >
                      {/* Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background:
                            "linear-gradient(to right, #e3f0f9, #d6e6ef)",
                          padding: "12px",
                          borderBottom: "1px solid #e5e7eb",
                          backgroundImage: `url(${MembershipBg})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <div>
                            {/* <CheckOutlined style={{ color: "#1976d2" }} /> */}
                            <div
                              className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${
                                item?.code === "SINGLE"
                                  ? "from-[#81CAF4] to-[#58B4E9]"
                                  : item?.code === "TWIN"
                                    ? "from-[#5DEB6D] to-[#34CF47]"
                                    : item?.code === "FAMILY"
                                      ? "from-[#35D9D4] to-[#1DBBB6]"
                                      : ""
                              }`}
                            >
                              <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                <span className="font-medium text-sm">
                                  {item?.code === "SINGLE"
                                    ? item?.description.split(" ")[0]
                                    : item?.code === "TWIN"
                                      ? item?.description.split(" ")[0]
                                      : item?.code === "FAMILY"
                                        ? item?.description.split(" ")[0]
                                        : ""}
                                </span>
                                <span className="text-xs font-normal text-gray-500">
                                  {item?.description.split(" ")[1]}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div className="text-lg font-semibold text-brand-White">
                            DOXZON
                          </div>
                          <div className="text-[8px] font-semibold text-brand-White">
                            Technology for Health
                          </div>
                        </div>
                      </div>

                      {/* Body */}
                      <div className="p-3">
                        <p className="font-inter font-normal text-sm mb-3">
                          Supercharge your health with exclusive offers on our
                          every healthcare service....{" "}
                          <span className="underline text-[#288DDA]">
                            Know more
                          </span>
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="font-inter font-medium text-[12px]">
                            Activate membership to start saving
                          </span>
                          <button
                            style={{
                              backgroundImage:
                                "linear-gradient(90.6deg, #11B0BD 6.71%, #2187BC 99.78%)",
                            }}
                            className="w-20 p-1.5 text-brand-White rounded-md"
                            onClick={handleNavigateToMemberhsip}
                          >
                            Activate
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
              )}
            </div>
            <div className="p-4 rounded-md border min-h-[265px] w-[356px] sm:w-full">
              <div className="mb-4 border border-neutral-200"></div>
              <div className="mb-3 text-sm font-semibold font-sans">
                Price Details
              </div>
              <div className="flex justify-between items-center mb-3">
                <div className="text-xs text-zinc-800 font-sans font-medium">
                  Price ({totalQuantity || cartData?.cartItemsCount}{" "}
                  {totalQuantity > 1 || cartData?.cartItemsCount > 1
                    ? "items"
                    : "item"}
                  )
                </div>
                <div className="text-sm text-zinc-800 font-sans font-medium">
                  <span className="text-sm font-normal text-gray-400 mr-0.5">
                    {`${CURRENCYCODE} `}
                  </span>{" "}
                  {grandTotalPaidAmount?.toFixed(2)}
                </div>
              </div>
              {membershipAvailed && (
                <div className="flex justify-between items-center mb-3">
                  <p className="text-xs text-[#117F0D] font-sans font-medium">
                    Total Discount
                  </p>
                  <div className="text-sm text-zinc-800 font-sans font-medium">
                    <span className="text-sm font-normal text-gray-400 mr-0.5">
                      {`${CURRENCYCODE} `}
                    </span>{" "}
                    {calculateTotalSavedAmt()?.toFixed(2)}
                  </div>
                </div>
              )}
              {/* <div className="flex justify-between items-center mb-4">
                            <div className="text-xs text-zinc-800 font-sans font-medium">
                                Delivery Charges
                            </div>
                            <div className="flex gap-1.5 items-center">
                                <span className="text-sm text-gray-500 line-through font-sans font-medium">
                                    INR50
                                </span>
                                <span className="text-xs text-lime-600 font-sans font-medium">
                                    Free
                                </span>
                            </div>
                        </div> */}
              <div className="mb-4 border border-slate-400" />
              <div className="px-2.5 py-3 mb-4 bg-green-50 rounded-sm border-green-200 border-[0.7px]">
                <div className="flex justify-between items-center">
                  <div className="text-xs text-zinc-800 font-sans font-medium">
                    Total Payable
                  </div>
                  <div>
                    {membershipAvailed && cartData ? (
                      <div className="flex items-center gap-1 text-base font-bold leading-4 text-zinc-800">
                        <span className="text-sm font-normal text-gray-400 mr-0.5">
                          {`${CURRENCYCODE} `}
                        </span>
                        <span className="line-through">
                          {grandTotalPaidAmount?.toFixed(2)}
                        </span>
                        <span>
                          {(
                            Number(grandTotalPaidAmount) -
                            calculateTotalSavedAmt()
                          )?.toFixed(2) || ""}
                        </span>
                      </div>
                    ) : (
                      <span className="text-base font-bold leading-4 text-zinc-800">
                        {" "}
                        <span className="text-sm font-normal text-gray-400 mr-0.5">
                          {`${CURRENCYCODE} `}
                        </span>{" "}
                        {grandTotalPaidAmount?.toFixed(2)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                disabled={cartLoader}
                className="py-2 w-full mb-2 text-sm font-semibold text-white bg-cyan-600 rounded"
                onClick={() => handleProceedPayment("Digital")}
              >
                Proceed to pay
              </button>
            </div>
          </div>
        </div>

        {/* Pay type selection */}
        <Modal
          open={payOptionMod}
          onCancel={handlePayModCancel}
          footer={[]}
          width={"30%"}
        >
          <div className="w-full">
            <p className="text-lg font-medium">Payment Options :</p>
            <div className="m-6">
              <button
                disabled={cartLoader}
                className="py-2 w-full mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => handleProceedPayment("Digital")}
              >
                Digital
              </button>
              <button
                disabled={cartLoader}
                // onClick={() => {
                //     message.success('Payment link shared successfully!!');
                //     handlePayModCancel();
                //     return;
                // }}
                onClick={() => handleProceedPayment("Share_Link")}
                className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Share payment link
              </button>
              <button
                disabled={cartLoader}
                className="py-2 w-full mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => handleProceedPayment("VirtualCash")}
              >
                Virtual Cash
              </button>
              <p className="font-extralight text-sm m-0">
                (Wallet balance:{" "}
                <span className="text-sm font-normal text-gray-400 mr-0.5">
                  {`${CURRENCYCODE} `}
                </span>{" "}
                {userCurrWallet?.amount?.toFixed(2)})
              </p>
            </div>
          </div>
        </Modal>

        {/* Select from existing address */}
        <Modal
          title={
            <span className="font-sans font-semibold text-sm text-[#189FAA]">
              Choose Location
            </span>
          }
          closable={{ "aria-label": "Custom Close Button" }}
          open={isAddressesModalOpen}
          onCancel={handleCloseDefAddChangeMod}
          footer={[]}
          destroyOnClose
        >
          <div>
            <p className="text-xs font-sans font-medium text-black leading-5">
              Select a delivery address location or enter a pin code to see
              product availability and delivery options
            </p>
            <div className="flex gap-3 mt-3">
              <div className="flex w-full">
                <input
                  type="text"
                  placeholder="Enter your pin code"
                  className="px-4 w-full h-8 text-xs placeholder:text-xs rounded border border-gray-300 text-neutral-400 outline-none"
                />
              </div>
              <button className="px-3.5 py-2 text-xs font-semibold text-white bg-[#189FAA] rounded">
                Apply
              </button>
            </div>
            <div
              className="border rounded-md p-2 mt-3 flex justify-between cursor-pointer"
              onClick={handleNewAddressMod}
            >
              <p className="text-sm font-sans font-medium">Add new address</p>
              <IoMdAddCircle className="w-5 h-5 text-[#189FAA]" />
            </div>
            <p className="text-sm font-sans font-semibold mt-3">
              Saved addresses
            </p>
            <div className="space-y-3 mt-4 h-[250px] overflow-y-scroll scrollWidth">
              {addresses.map((address, index) => (
                <label
                  key={index}
                  className={`flex justify-between gap-3 p-4 border rounded-lg cursor-pointer transition ${
                    selected === index
                      ? "border-cyan-500 bg-cyan-50"
                      : "border-gray-300"
                  }`}
                >
                  <div className="">
                    <p className="font-semibold mb-2 font-sans text-sm">
                      {address.address1}
                    </p>
                    <p className="text-xs text-gray-600 font-sans font-medium">
                      {address.pinCode}
                    </p>
                  </div>
                  <input
                    type="radio"
                    name="address"
                    checked={selected === index}
                    onChange={() => handleSelectedAddress(address, index)}
                    className="mt-1 accent-cyan-600"
                  />
                </label>
              ))}
            </div>

            <div className="flex justify-end mt-6 gap-4">
              <button
                onClick={handleCloseDefAddChangeMod}
                disabled={saveLoader}
                className="px-4 py-2 text-[#189FAA] font-sans font-medium border border-cyan-600 rounded-md disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateDefaultAddress}
                disabled={saveLoader}
                className="px-4 py-2 bg-[#189FAA] font-sans font-semibold text-white rounded-md disabled:cursor-not-allowed disabled:opacity-50"
              >
                Confirm Location
              </button>
            </div>
          </div>
        </Modal>

        {/* Add new address */}
        <Modal
          title={
            <span className="text-sm font-semibold font-sans text-[#189FAA]">
              Add Address
            </span>
          }
          open={newAddModal}
          onCancel={handleCloseNewAddressMod}
          footer={null}
        >
          <form className="space-y-4 mt-3">
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Pin Code"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <select
                value={formData.state}
                onChange={handleChange}
                name="state"
                className="w-full py-2 px-3 border rounded text-xs text-gray-400 font-sans  outline-none"
              >
                <option value="" disabled>
                  Select State
                </option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>
                    {state.stateName}
                  </option>
                ))}
              </select>
              <select
                value={formData.country}
                onChange={handleChange}
                name="country"
                className="w-full px-3 py-2 border rounded font-sans text-gray-400  text-xs outline-none"
              >
                <option value="" disabled>
                  Select Country
                </option>
                {countries.map((country) => (
                  <option key={country.country_Id} value={country.country_Id}>
                    {country.country_Name}
                  </option>
                ))}
              </select>
            </div>
            <textarea
              placeholder="Full Address"
              rows="3"
              value={formData.address1}
              name="address1"
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
            />

            <div className="flex justify-end gap-4 mt-4">
              <button
                type="button"
                disabled={saveLoader}
                onClick={handleCloseNewAddressMod}
                className="px-4 py-1 border border-cyan-600 font-sans text-sm font-medium text-cyan-600 rounded disabled:cursor-not-allowed disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                type="submits"
                disabled={saveLoader}
                className="px-4 py-1 bg-[#189FAA] font-sans text-sm text-white font-semibold rounded disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handleAddressSave}
              >
                Save Address
              </button>
            </div>
          </form>
        </Modal>
      </div>
      <Modal
        open={isPrescriptionPreviewOpen}
        title="Prescription preview"
        footer={null}
        onCancel={() => setIsPrescriptionPreviewOpen(false)}
      >
        {activePrescriptionPreview.image && (
          <img
            src={activePrescriptionPreview.image}
            alt={activePrescriptionPreview.fileName || "Prescription"}
            className="max-h-[70vh] w-full object-contain"
          />
        )}
      </Modal>
    </Layout>
  );
}
export default MyCart;
